import React from 'react';
import SectionHeader from './SectionHeader';
import CurrencyInput from './CurrencyInput';
import NotesInput from './NotesInput';

/**
 * Section 4 — Auto & Transport
 */
export default function StepAutoTransport({ data = {}, onChange }) {
  function set(field, value) {
    onChange({ ...data, [field]: value });
  }

  function setAutoField(autoKey, field, value) {
    const current = data[autoKey] || {};
    onChange({ ...data, [autoKey]: { ...current, [field]: value } });
  }

  const auto1 = data.auto_1 || {};
  const auto2 = data.auto_2 || {};
  const auto3 = data.auto_3 || {};

  const autoPaymentsTotal =
    (Number(auto1.amount) || 0) +
    (Number(auto2.amount) || 0) +
    (Number(auto3.amount) || 0);

  const otherFields = [
    { key: 'gas_fuel', label: 'Gas / Fuel' },
    { key: 'license_registration', label: 'License & Registration' },
    { key: 'parking_tolls', label: 'Parking & Tolls' },
    { key: 'service_maintenance', label: 'Service & Maintenance (tires, oil, etc.)' },
    { key: 'auto_insurance', label: 'Auto Insurance' },
    { key: 'public_transportation', label: 'Public Transportation' },
  ];

  const otherTotal = otherFields.reduce(
    (sum, f) => sum + (Number(data[f.key]) || 0),
    0
  );

  const total = autoPaymentsTotal + otherTotal;

  return (
    <div>
      <SectionHeader number={4} title="Auto & Transport" />

      {/* Auto payments */}
      {[
        { key: 'auto_1', label: 'Auto Lease / Loan Payment #1', auto: auto1 },
        { key: 'auto_2', label: 'Auto Lease / Loan Payment #2', auto: auto2 },
        { key: 'auto_3', label: 'Auto Lease / Loan Payment #3', auto: auto3 },
      ].map(({ key, label, auto }) => (
        <div key={key} className="mb-3">
          <CurrencyInput
            id={`${key}_amount`}
            label={label}
            value={auto.amount ?? null}
            onChange={(val) => setAutoField(key, 'amount', val)}
          />
          <div className="form-check ms-1 mt-n2">
            <input
              className="form-check-input"
              type="checkbox"
              id={`${key}_lease`}
              checked={!!auto.is_lease}
              onChange={(e) => setAutoField(key, 'is_lease', e.target.checked)}
            />
            <label className="form-check-label text-muted small" htmlFor={`${key}_lease`}>
              This is a lease
            </label>
          </div>
        </div>
      ))}

      <hr className="my-3" />

      <div className="cashflow-field-grid">
        {otherFields.map(({ key, label }) => (
          <CurrencyInput
            key={key}
            id={key}
            label={label}
            value={data[key] ?? null}
            onChange={(val) => set(key, val)}
          />
        ))}
      </div>

      {total > 0 && (
        <div className="cashflow-total-box mt-3">
          <span className="fw-semibold">4: Total Auto & Transport</span>
          <span className="cashflow-total-amount">
            ${total.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
          </span>
        </div>
      )}

      <NotesInput value={data.notes} onChange={(val) => set('notes', val)} />
    </div>
  );
}
